import React, { useContext } from "react";
import { TableContext } from "../../index";
import { CardTypes } from "./domainNameCardService";

function DomainManagementTableHeader() {

    const { config } = useContext(TableContext);

    const onCreateClick = () => {
        const { showModal } = config;
        showModal({ cardType: CardTypes.CREATE })
    }

    return (
        <>
            <div className="oct_analysis-header-v2 mt-0">
                <div className="oct_analysis-title-section">
                    <h2>Domain List</h2>
                </div>
                <div className="oct_analysis-actions">
                    <button
                        className="oct_btn-export-v2"
                        onClick={onCreateClick}
                    >
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}

export default DomainManagementTableHeader;